import AllTimersView from "@/components/AllTimersView/allTimersView.component";
import BasePage from "@/infrastructure/BasePage/basePage.component";
import { Card } from "@/shadcn/components/ui/card";
import React from "react";

const TimersPage: React.FC = () => {
  return (
    <BasePage currPage="timers">
      <Card className="flex flex-col w-full h-full rounded-sm dark:bg-background max-w-[100vw]">
        <AllTimersView />
      </Card>
    </BasePage>
  );
};

export default TimersPage;
